import { render, staticRenderFns } from "./BlogLayout.vue?vue&type=template&id=f1047532&"
import script from "./BlogLayout.vue?vue&type=script&lang=js&"
export * from "./BlogLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports